var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconIdCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-id-card_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161160",
  fill: "none",
  d: "M0 0h64v64H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31321"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31320",
  clipPath: "url(#icon-id-card_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38620",
  d: "M54.857 32A22.857 22.857 0 1132 9.143 22.857 22.857 0 0154.857 32",
  fill: "#f9a23a"
})))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31323"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31322",
  clipPath: "url(#icon-id-card_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38621",
  d: "M50.536 45.073H13.464a2.55 2.55 0 01-2.55-2.55V21.478a2.55 2.55 0 012.55-2.55h37.072a2.55 2.55 0 012.55 2.55v21.044a2.55 2.55 0 01-2.55 2.55",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38622",
  d: "M13.464 18.108h37.072a3.373 3.373 0 013.369 3.369v21.045a3.373 3.373 0 01-3.369 3.369H13.464a3.373 3.373 0 01-3.369-3.369V21.477a3.374 3.374 0 013.369-3.369m37.072 26.15a1.733 1.733 0 001.731-1.731v-21.05a1.733 1.733 0 00-1.731-1.731H13.464a1.733 1.733 0 00-1.73 1.731v21.045a1.733 1.733 0 001.731 1.731z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38623",
  d: "M34.85 32.121h-1.682a.819.819 0 01-.819-.819.819.819 0 01.819-.819h1.682a.82.82 0 010 1.64z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38624",
  d: "M39.262 32.121H37.58a.82.82 0 01-.819-.819.819.819 0 01.819-.819h1.682a.82.82 0 010 1.64z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38625",
  d: "M48.093 27.238H33.167a.819.819 0 01-.819-.819.819.819 0 01.819-.819h14.926a.82.82 0 010 1.64z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38626",
  d: "M27.541 36.541l-2.4-.423a1.942 1.942 0 01-1.6-1.913v-.272a4.73 4.73 0 001.413-3.506c0-2.356-.78-4.267-3.281-4.267s-3.277 1.91-3.277 4.266a4.731 4.731 0 001.413 3.506v.272a1.942 1.942 0 01-1.6 1.913l-2.4.423a1.942 1.942 0 00-1.6 1.913v1.377a.607.607 0 00.607.607H28.54a.607.607 0 00.607-.607v-1.377a1.942 1.942 0 00-1.606-1.912",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38627",
  d: "M28.542 41.258H14.801a1.428 1.428 0 01-1.427-1.427v-1.377a2.755 2.755 0 012.282-2.72l2.4-.423a1.119 1.119 0 00.925-1.037 5.7 5.7 0 01-1.411-3.846c0-4.427 2.57-5.086 4.1-5.086s4.1.661 4.1 5.086a5.7 5.7 0 01-1.411 3.846 1.12 1.12 0 00.925 1.037l2.4.423a2.755 2.755 0 012.282 2.72v1.377a1.429 1.429 0 01-1.425 1.427m-13.527-1.64h13.315v-1.166a1.121 1.121 0 00-.928-1.1l-2.4-.423a2.754 2.754 0 01-2.282-2.72v-.638l.27-.244a3.922 3.922 0 001.142-2.9c0-3.443-1.787-3.443-2.459-3.443s-2.459 0-2.459 3.443a3.924 3.924 0 001.142 2.9l.271.244v.635a2.754 2.754 0 01-2.282 2.72l-2.4.423a1.12 1.12 0 00-.93 1.107z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38628",
  d: "M48.093 39.183H33.167a.819.819 0 01-.819-.82.819.819 0 01.819-.819h14.926a.82.82 0 010 1.64",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38629",
  d: "M15.099 22.094h13.145a1.727 1.727 0 011.725 1.725v15.714a1.727 1.727 0 01-1.725 1.725H15.099a1.726 1.726 0 01-1.725-1.725V23.819a1.727 1.727 0 011.725-1.725m13.145 17.524l.084-15.8-13.229-.085a.085.085 0 00-.085.085v15.714z",
  fill: "#29398c"
})))));
export default __webpack_public_path__ + "static/icon-id-card.e14c1da69a3695373d30842b2cb4c48f.svg";
export { SvgIconIdCard as ReactComponent };